
import type { SVGProps } from 'react';
const SvgPassenger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      d="M9.42 4.403h4.16c.369-.012.735.078 1.059.262.301.16.56.394.756.682.198.23.352.496.454.786.1.285.15.587.151.89v6.08a.86.86 0 0 1-.202.55.6.6 0 0 1-.378.236.6.6 0 0 1-.479 0 1.1 1.1 0 0 1-.428-.288 1 1 0 0 1-.177-.367V7.627a.2.2 0 0 0 0-.158.4.4 0 0 0 0 .157v15.199c-.043.163-.12.316-.224.447a1.2 1.2 0 0 1-.38.313 1 1 0 0 1-.505.366 1.2 1.2 0 0 1-.68 0 .98.98 0 0 1-.58-.367.74.74 0 0 1-.253-.445v-9.04a.25.25 0 0 0 0-.158.17.17 0 0 0-.151 0 .25.25 0 0 0 0 .158v8.726c.01.2-.052.396-.176.55-.168.193-.388.33-.63.393a1.03 1.03 0 0 1-.959 0c-.16-.066-.3-.173-.41-.31s-.186-.301-.22-.476a.6.6 0 0 1 0-.21.9.9 0 0 0 0-.236V7.626a.24.24 0 0 0 0-.183.17.17 0 0 0-.151 0h-.151a.35.35 0 0 0 0 .157v5.503a1.1 1.1 0 0 1-.328.576.9.9 0 0 1-.605.236.6.6 0 0 1-.351-.077.64.64 0 0 1-.254-.263A1.4 1.4 0 0 1 7 13.103V6.29a2.4 2.4 0 0 1 .857-1.336 2.46 2.46 0 0 1 1.563-.55m.731-3.825c.165-.19.368-.34.594-.44.227-.099.472-.146.717-.137.257-.008.513.039.751.138.239.099.455.248.636.439.18.173.322.384.417.62.096.234.143.487.137.742.003.259-.045.515-.14.754a1.927 1.927 0 0 1-1.8 1.212 1.7 1.7 0 0 1-.714-.148 1.8 1.8 0 0 1-.598-.43 1.9 1.9 0 0 1-.414-.634 2 2 0 0 1-.14-.754 1.9 1.9 0 0 1 .137-.743 1.8 1.8 0 0 1 .417-.62"
    />
  </svg>
);
export default SvgPassenger;
